import { useEffect, useState } from "react";
import {
    Drawer, Toolbar, IconButton, List, ListItemButton, ListItemText, Alert, LinearProgress, useTheme, ListItemIcon, Box
} from "@mui/material";
import Menu from "@mui/icons-material/Menu";
import MenuOpen from "@mui/icons-material/MenuOpen";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { getTools, Tool } from "../../utils/billingUtil";
import {drawerSx, navRowSx, navRowTextSx, hamburgerIconSx, hamburgerButtonSx} from "./styles";
import {SignalCellularAlt} from "@mui/icons-material";

export default function Navbar() {
    const t = useTheme();
    const [open, setOpen] = useState(true);
    const [tools, setTools] = useState<Tool[] | null>(null);
    const [err, setErr] = useState<string | null>(null);
    const { getAccessToken } = useAuth();
    const nav = useNavigate();
    const { pathname } = useLocation();

    useEffect(() => {
        (async () => {
            try {
                const token = await getAccessToken?.();
                const { tools } = await getTools(token ?? undefined);
                setTools(
                    tools.filter((tool: Tool) => tool.status.toLowerCase() === "active"),
                );
            } catch (e: any) { setErr(e?.message ?? String(e)); }
        })();
    }, [getAccessToken]);

    return (
        <Drawer variant="permanent" sx={drawerSx(t, open)}>
            {/* Toggle row */}
            <IconButton sx={hamburgerButtonSx(t, open)} onClick={() => setOpen(o => !o)} size="small" >
                {open ? <SignalCellularAlt sx={hamburgerIconSx(open)} /> : <Menu sx={hamburgerIconSx(open)}/>}
            </IconButton>

            {/* Inline feedback */}
            {!tools && !err && <LinearProgress sx={{ my: 1 }} />}
            {err && (
                <Alert severity="error" variant="outlined" sx={{ my: 1 }} >
                    {open ? err : "Error"}
                </Alert>
            )}

            {/* Nav items */}
            <List dense disablePadding>
                {tools?.map(({ code, name }) => {
                    const to = `/${code}`;
                    const active = pathname.startsWith(to);
                    return (
                        <ListItemButton key={code} selected={active} onClick={() => nav(to)} sx={navRowSx(t, open)}>
                            <ListItemText primary={name} sx={navRowTextSx(t, open)}/>
                        </ListItemButton>
                    );
                })}
            </List>
        </Drawer>
    );
}
